import { HeaderMenu } from '../types/header-menu.type';

export const headerMenuData: HeaderMenu[] = [
  {
    name: 'home.categories',
    icon: 'grid-apps',
    link: '/categories',
  },
  {
    name: 'header.suppliers',
    icon: 'user-2',
    link: 'industries/suppliers',
  },
  {
    name: 'header.customers',
    icon: 'user-2',
    link: 'industries/customers',
  },
  {
    name: 'header.auctions',
    icon: 'dollar-circle',
    link: '/auctions',
  },
  {
    name: 'header.tenders',
    icon: 'dollar-square',
    link: '/tenders',
  },
];
